import { render, staticRenderFns } from "./ConventionCaTerritoryItem.vue?vue&type=template&id=6312a1d7&scoped=true"
import script from "./ConventionCaTerritoryItem.vue?vue&type=script&lang=js"
export * from "./ConventionCaTerritoryItem.vue?vue&type=script&lang=js"
import style0 from "./ConventionCaTerritoryItem.vue?vue&type=style&index=0&id=6312a1d7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312a1d7",
  null
  
)

export default component.exports